<div id="container" class="p-grid p-md-offset-2">
    <article>
        <div class="p-md-10">
            <div class="p-md-10">
                <h1>GIF Weirdness Application</h1>
                <p>Did you know that every GIF has a weirdness indicator? That's what I use to calculate your weirdness based on the GIFs you like.
                    You select 5 GIFs with different weirdness levels as you like them to be and at the end, I present you with your weirdness score. </p>
                    
                    <p>Try it out here: <a href="https://gif-weirdness.web.app">GIF Weirdness Calculator</a></p>
                    
                    <p>The application is developed in Angular 9 and communicates with GIPHY API to generate the GIFs. Developed in less than 30h, it was pretty fun to play with!</p>
                <p><b>Github link: </b><a href="https://github.com/lejdiprifti/weirdness-calculator" target="_blank">https://github.com/lejdiprifti/weirdness-calculator</a></p>
                </div>
                <div class="p-md-10">
                    <iframe width="100%" height="415" 
                    src="https://www.youtube.com/embed/mFEkv0OLeCA" frameborder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
        </div>
    </article>
    <div class="fb-share-button" data-href="https://lejdiprifti.web.app" data-layout="button_count" data-size="small"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">Share</a></div>
</div>
